import gql from "graphql-tag";

export const FRAGMENT_MEDIA_ITEM = gql`
  fragment MediaItemFragment on MediaItem {
    altText
    sourceUrl
    mediaDetails {
      sizes {
        file
        fileSize
        height
        mimeType
        name
        sourceUrl
        width
      }
    }
  }
`;

export const FRAGMENT_NEIGHBORHOOD_DETAILS = gql`
  ${FRAGMENT_MEDIA_ITEM}
  fragment NeighborhoodDetailsFragment on Neighborhood {
    basePrice
    databaseId
    id
    slug
    status
    title
    types
    uri
    collection {
      collection
    }
    neighborhood {
      address1
      address2
      city
      eciIframe
      gravityFormId
      lassoCommunityProjectId
      hours
      latitude
      legal
      longitude
      phone
      siteMapPdfEPub
      lotMaps {
        ...MediaItemFragment
      }
      state
      status
      zip
      alternatingContent {
        button
        button2
        buttonColor
        buttonColor2
        buttonText
        buttonText2
        description
        fieldGroupName
        id
        link
        link2
        title
        videoEmbed
        image {
          ...MediaItemFragment
        }
      }
      popularPlans {
        ... on Plan {
          databaseId
          id
          slug
          title
          floorplanDetails {
            bathroomsMax
            bathroomsMin
            bedroomsMax
            bedroomsMin
            collection
            displayTitle
            finishedSqrFt
            mainSqrFt
            features {
              feature
            }
          }
        }
      }
      saleTeamMembers {
        name
        email
        image {
          ...MediaItemFragment
        }
      }
      thumbnail {
        ...MediaItemFragment
      }
    }
  }
`;

export const FRAGMENT_EVENT_DETAILS = gql`
  ${FRAGMENT_MEDIA_ITEM}
  ${FRAGMENT_NEIGHBORHOOD_DETAILS}
  fragment EventDetailsFragment on Event {
    content
    databaseId
    id
    slug
    title
    uri
    eventDetails {
      collection
      directionsUrl
      endDateTime
      eventSummary
      fieldGroupName
      location
      startDateTime
      image {
        ...MediaItemFragment
      }
      thumbnail {
        ...MediaItemFragment
      }
      neighborhood {
        ...NeighborhoodDetailsFragment
      }
    }
  }
`;

export const FRAGMENT_ORGANISMS = gql`
  ${FRAGMENT_MEDIA_ITEM}
  fragment OrganismsFragment on Page {
    databaseId
    id
    title
    hlOrganisms {
      hlOrganism {
        address1
        address2
        arrow
        attribution
        autoplayDelay
        autoplaySlider
        backgroundColor
        backgroundImageOpacity
        backgroundOverlayColor
        border
        borderColor
        borderInset
        borderWidth
        brandWindowLayout
        button1
        button1Color
        button1Target
        button1Text
        button2
        button2Color
        button2Target
        button2Text
        button3
        button3Color
        button3Target
        button3Text
        city
        collection
        containerWidth
        contentTheme
        cssClasses
        customBackgroundOverlayColor
        description
        fieldGroupName
        formHeader
        gfid
        fullBleed
        hideInfo
        hours
        id
        imageLink
        latitude
        legal
        link1
        link2
        link3
        longitude
        mapArbitraryLayout
        mapWithInfoMapType
        markerTitle
        neighborhoodsMapLayout
        phone
        primaryHeadingLevel
        productType
        rounded
        siteMapCtaLayout
        splitContentLayout
        state
        text1
        thumbnailCount
        title1
        title2
        title3
        type
        videoEmbedCode
        virtualTourCustomEmbedCode
        virtualTourEmbedType
        virtualTourLayout
        virtualTourUrl
        zip
        backgroundImage {
          ...MediaItemFragment
        }
        gallery {
          sourceUrl
          title
          mediaDetails {
            sizes {
              file
              fileSize
              height
              mimeType
              name
              sourceUrl
              width
            }
          }
        }
        hiddenFormFields {
          inputSelector
          inputValue
        }
        image {
          ...MediaItemFragment
        }
        item {
          attribution
          backgroundColor
          brandWindowLayout
          button1
          button1Color
          button1Target
          button1Text
          button2
          button2Color
          button2Target
          button2Text
          button3
          button3Color
          button3Target
          button3Text
          contentTheme
          cssClasses
          description
          fieldGroupName
          fullBleed
          id
          imageLink
          link1
          link2
          link3
          splitContentLayout
          text1
          title1
          title2
          title3
          type
          virtualTourCustomEmbedCode
          virtualTourEmbedType
          virtualTourLayout
          virtualTourUrl
          item {
            backgroundColor
            button1
            button1Color
            button1Target
            button1Text
            button2
            button2Color
            button2Target
            button2Text
            containerWidth
            cssClasses
            description
            fieldGroupName
            id
            link1
            link2
            selectHomes {
              ... on Home {
                databaseId
              }
            }
            selectPlans {
              ... on Plan {
                databaseId
              }
            }
            title1
            type
            item {
              description
              fieldGroupName
              title1
              title2
            }
          }
          backgroundImage {
            ...MediaItemFragment
          }
          gallery {
            sourceUrl
            title
            mediaDetails {
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
          }
          image {
            ...MediaItemFragment
          }
        }
        salesTeamMembers {
          name
          image {
            ...MediaItemFragment
          }
        }
      }
    }
  }
`;

export const FRAGMENT_CAMPAIGN_ORGANISMS = gql`
  ${FRAGMENT_MEDIA_ITEM}
  fragment CampaignOrganismsFragment on Campaign {
    databaseId
    id
    title
    hlOrganisms {
      hlOrganism {
        address1
        address2
        arrow
        attribution
        autoplayDelay
        autoplaySlider
        backgroundColor
        backgroundImageOpacity
        backgroundOverlayColor
        border
        borderColor
        borderInset
        borderWidth
        brandWindowLayout
        button1
        button1Color
        button1Target
        button1Text
        button2
        button2Color
        button2Target
        button2Text
        button3
        button3Color
        button3Target
        button3Text
        city
        collection
        containerWidth
        contentTheme
        cssClasses
        customBackgroundOverlayColor
        description
        fieldGroupName
        formHeader
        gfid
        fullBleed
        hideInfo
        hours
        id
        imageLink
        latitude
        legal
        link1
        link2
        link3
        longitude
        mapArbitraryLayout
        mapWithInfoMapType
        markerTitle
        neighborhoodsMapLayout
        phone
        primaryHeadingLevel
        productType
        rounded
        siteMapCtaLayout
        splitContentLayout
        state
        text1
        thumbnailCount
        title1
        title2
        title3
        type
        videoEmbedCode
        virtualTourCustomEmbedCode
        virtualTourEmbedType
        virtualTourLayout
        virtualTourUrl
        zip
        backgroundImage {
          ...MediaItemFragment
        }
        gallery {
          sourceUrl
          title
          mediaDetails {
            sizes {
              file
              fileSize
              height
              mimeType
              name
              sourceUrl
              width
            }
          }
        }
        hiddenFormFields {
          inputSelector
          inputValue
        }
        image {
          ...MediaItemFragment
        }
        item {
          attribution
          backgroundColor
          brandWindowLayout
          button1
          button1Color
          button1Target
          button1Text
          button2
          button2Color
          button2Target
          button2Text
          button3
          button3Color
          button3Target
          button3Text
          contentTheme
          cssClasses
          description
          fieldGroupName
          fullBleed
          id
          imageLink
          link1
          link2
          link3
          splitContentLayout
          text1
          title1
          title2
          title3
          type
          virtualTourCustomEmbedCode
          virtualTourEmbedType
          virtualTourLayout
          virtualTourUrl
          item {
            backgroundColor
            button1
            button1Color
            button1Target
            button1Text
            button2
            button2Color
            button2Target
            button2Text
            containerWidth
            cssClasses
            description
            fieldGroupName
            id
            link1
            link2
            selectHomes {
              ... on Home {
                databaseId
              }
            }
            selectPlans {
              ... on Plan {
                databaseId
              }
            }
            title1
            type
            item {
              description
              fieldGroupName
              title1
              title2
            }
          }
          backgroundImage {
            ...MediaItemFragment
          }
          gallery {
            sourceUrl
            title
            mediaDetails {
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
          }
          image {
            ...MediaItemFragment
          }
        }
        salesTeamMembers {
          name
          image {
            ...MediaItemFragment
          }
        }
      }
    }
  }
`;

export const FRAGMENT_PROMOTION_ORGANISMS = gql`
  ${FRAGMENT_MEDIA_ITEM}
  fragment PromotionOrganismsFragment on Promotion {
    databaseId
    id
    title
    hlOrganisms {
      hlOrganism {
        address1
        address2
        arrow
        attribution
        autoplayDelay
        autoplaySlider
        backgroundColor
        backgroundImageOpacity
        backgroundOverlayColor
        border
        borderColor
        borderInset
        borderWidth
        brandWindowLayout
        button1
        button1Color
        button1Target
        button1Text
        button2
        button2Color
        button2Target
        button2Text
        button3
        button3Color
        button3Target
        button3Text
        city
        collection
        containerWidth
        contentTheme
        cssClasses
        customBackgroundOverlayColor
        description
        fieldGroupName
        formHeader
        gfid
        fullBleed
        hideInfo
        hours
        id
        imageLink
        latitude
        legal
        link1
        link2
        link3
        longitude
        mapArbitraryLayout
        mapWithInfoMapType
        markerTitle
        neighborhoodsMapLayout
        phone
        primaryHeadingLevel
        productType
        rounded
        siteMapCtaLayout
        splitContentLayout
        state
        text1
        thumbnailCount
        title1
        title2
        title3
        type
        videoEmbedCode
        virtualTourCustomEmbedCode
        virtualTourEmbedType
        virtualTourLayout
        virtualTourUrl
        zip
        backgroundImage {
          ...MediaItemFragment
        }
        gallery {
          sourceUrl
          title
          mediaDetails {
            sizes {
              file
              fileSize
              height
              mimeType
              name
              sourceUrl
              width
            }
          }
        }
        hiddenFormFields {
          inputSelector
          inputValue
        }
        image {
          ...MediaItemFragment
        }
        item {
          attribution
          backgroundColor
          brandWindowLayout
          button1
          button1Color
          button1Target
          button1Text
          button2
          button2Color
          button2Target
          button2Text
          button3
          button3Color
          button3Target
          button3Text
          contentTheme
          cssClasses
          description
          fieldGroupName
          fullBleed
          id
          imageLink
          link1
          link2
          link3
          splitContentLayout
          text1
          title1
          title2
          title3
          type
          virtualTourCustomEmbedCode
          virtualTourEmbedType
          virtualTourLayout
          virtualTourUrl
          item {
            backgroundColor
            button1
            button1Color
            button1Target
            button1Text
            button2
            button2Color
            button2Target
            button2Text
            containerWidth
            cssClasses
            description
            fieldGroupName
            id
            link1
            link2
            selectHomes {
              ... on Home {
                databaseId
              }
            }
            selectPlans {
              ... on Plan {
                databaseId
              }
            }
            title1
            type
            item {
              description
              fieldGroupName
              title1
              title2
            }
          }
          backgroundImage {
            ...MediaItemFragment
          }
          gallery {
            sourceUrl
            title
            mediaDetails {
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
          }
          image {
            ...MediaItemFragment
          }
        }
        salesTeamMembers {
          name
          image {
            ...MediaItemFragment
          }
        }
      }
    }
  }
`;

export const BLOG_POST_FRAGMENT = gql`
  ${FRAGMENT_MEDIA_ITEM}
  fragment BlogPostFragment on BlogPost {
    content
    date
    slug
    title
    uri
    blogCategories {
      nodes {
        count
        name
        slug
      }
    }
    customPostDetails {
      excerpt
      subtitle
      thumbnail {
        ...MediaItemFragment
      }
      image {
        ...MediaItemFragment
      }
    }
  }
`;

export const TESTIMONIAL_FRAGMENT = gql`
  ${FRAGMENT_MEDIA_ITEM}
  fragment TestimonialFragment on Testimonial {
    content
    date
    slug
    title
    uri
    testimonialCategories {
      nodes {
        count
        name
        slug
      }
    }
    customPostDetails {
      excerpt
      subtitle
      thumbnail {
        ...MediaItemFragment
      }
      image {
        ...MediaItemFragment
      }
    }
  }
`;
